import { Component, OnInit, Inject,OnDestroy,ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { MatTableDataSource, MatDialog} from '@angular/material';
import { Escalationdetails, NotificationForCreationResponse,NotificationDelete, getNotification, getNotificationById, checkAlertItem} from './../notification';
import { notificationService } from './../notification.service';
import { AddNotificationComponent } from './../add-notification/add-notification.component';
import { EditNotificationComponent } from './../edit-notification/edit-notification.component';
import { enumAlertSubType, enumUIFeatureView, enumUIAction, enumUIView } from '../../../app-settings';
import { RollbarService } from '../../../rollbar';
import * as Rollbar from 'rollbar';
import { SessionCheckwithStaff, checkStaffData, generateAlertMessage, getFeatureNeedtoShow, getAddEditDeleteColumn , AuthFailedMessage } from '../../../app-general';
import { ApiService } from '../../../api.service';
import { AlertSharedService } from '../../../_services/index';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfirmMessageComponent } from '../../../confirm-message/confirm-message.component';
import { MAT_DIALOG_DATA} from '@angular/material';
import { MatDialogRef} from '@angular/material';
import { SessionCheck } from '../../../app-general';


@Component({
  selector: 'app-view-notification',
  templateUrl: './view-notification.component.html',
  providers: [ notificationService],
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./view-notification.component.scss']
})
export class ViewNotificationComponent implements OnInit,OnDestroy {
  bAddEdit:boolean=false;
  bDelete:boolean=false;
  checkicon;
  escalationData;
  arrowiconT = true;
  arrowiconF = false;
  preId=-1;
  collapsedIcon1= "keyboard_arrow_down";
  collapsedIcon = "keyboard_arrow_down";
  Notificationdetails:any[];
  Escalationdetail: Escalationdetails[];
  smcurrentScreenWidth: string = 'sm';
  xscurrentScreenWidth: string = 'xs';
  mdcurrentScreenWidth: string = 'md';
  displayedColumns: string[] = ['Level','AlarmNameId','TimetoEscalate','RepeatCycle','Repeats','Notify','Edit','Delete'];
  dataSource;
  SiteId = "1";
  LevelImgURL = "assets/images/";
  escalation;
  AlarmId = 1;
  esclationcount=-1;
  esclationCampus=-1;
  esclationBuilding=-1;
  esclationFloor=-1;
  esclationSubZone = -1;
  esclationsubtypeid=-1;
  deleteMSG;
  notifyloading = false;
  Campus_Id;
  Campus_Name;
  Building_Id;
  Building_Name;
  Floor_Id;
  Floor_Name;
  SubZone_Id;
  SubZone_Name;
  AlarmSubTypeId_Show = "";
  Val_Show = 0;
  showNotifyWarningImage = true;
  checkNotification = true;
  checkNotificationCount = 0;
  NotificationLevelTooltip = "WARNING: Previous notification level(s) has/have not been setup to escalate.For this level to execute,edit previous level.";
  RepeatCycleTooltip = "Repeat Cycle(minutes)";
  EscalateTooltip = "Time to Escalate(minutes)";
  contiNotifyAlertId;
  private _onDestroy: Subject<void> = new Subject<void>();
  constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<ViewNotificationComponent>,@Inject(RollbarService) private rollbar: Rollbar, @Inject(MAT_DIALOG_DATA) public data: any,
  private notificationService: notificationService,public dialog: MatDialog,private alertSharedService: AlertSharedService,private apiService: ApiService) 
  {
      mediaObserver.media$.subscribe((change: MediaChange) => {
        if (getFeatureNeedtoShow(enumUIFeatureView.Notification, enumUIAction.Notification_AddEditDelete) == enumUIView.Show) {
        this.bAddEdit = true;
        this.bDelete = true;
      }
      if (change.mqAlias == this.xscurrentScreenWidth) {
          this.setupTableforXtrasmallerwidth();
      }
      else if (change.mqAlias == this.smcurrentScreenWidth) {
          this.setupTableforXtrasmallerwidth();
      }
      else
      {
        this.setupFullTable();
      }	
    });
      this.Campus_Id = data.CampusId;
      this.Building_Id = data.BuildId;
      this.Floor_Id = data.FloorId;
      this.SubZone_Id = data.SubZoneId;
      this.AlarmId = data.AlarmId;
  }

 
    
// set table width and columns
setupTableforXtrasmallerwidth() {
  this.displayedColumns = ['AlarmNameId','TimetoEscalate','RepeatCycle','Repeats','Edit','Delete']; 
  this.displayedColumns = getAddEditDeleteColumn(this.displayedColumns,this.bAddEdit,this.bDelete);       
};

setupTableforsmallerwidth() {
  this.displayedColumns = ['Level','AlarmNameId','TimetoEscalate','RepeatCycle','Repeats','Edit','Delete'];  
  this.displayedColumns = getAddEditDeleteColumn(this.displayedColumns,this.bAddEdit,this.bDelete);    
};

setupTableformdwidth()
{
this.displayedColumns = ['Level','AlarmNameId','TimetoEscalate','RepeatCycle','Repeats','Edit','Delete'];
this.displayedColumns = getAddEditDeleteColumn(this.displayedColumns,this.bAddEdit,this.bDelete);
}

setupFullTable() {
  this.displayedColumns = ['Level','AlarmNameId','TimetoEscalate','RepeatCycle','Repeats','Notify','Edit','Delete'];  
  this.displayedColumns = getAddEditDeleteColumn(this.displayedColumns,this.bAddEdit,this.bDelete);      
};	

  ngOnInit() {
    try
    {
     
      if (getFeatureNeedtoShow(enumUIFeatureView.Notification, enumUIAction.Notification_AddEditDelete) == enumUIView.Show) {
        this.bAddEdit = true;
        this.bDelete = true;
      }
                  
     var notificationrequest : getNotification = 
     {
       siteId:this.SiteId,
       authKey: localStorage.getItem("Authkey"),
       alertId:this.AlarmId
     };
      this.getNotification(notificationrequest); 
      this.getStaffById();
    }
    catch (err) {
      throw new Error('notification.component.ts' + ' - ngOnInit() - ' + err.message);
    }
  }
  

  getStaffById()
  {  
    checkStaffData(this.apiService,this.alertSharedService);    
  }

  
//get campus details
getNotification(notificationrequest): void {
  try
  {
    
    var first_showData = [];
    var DataValue = [];
    var cnt = 0;
   
    this.notificationService.getNotification(notificationrequest).pipe(takeUntil(this._onDestroy))
      .subscribe((NotificationDetails : any[])=>{
   
        if (NotificationDetails["apiReturn"]!=null && NotificationDetails["apiReturn"]!=undefined)
        {                       
            if(NotificationDetails["apiReturn"] == "Invalid Auth Key")
            {                  
                AuthFailedMessage(this.dialog,this.router);  
                return;       
            }            
            this.Notificationdetails = [];
            var _this = this; 
           
            first_showData = [];
            DataValue = [];
            cnt = 0;
            console.log("esclationSubZone : " + this.esclationSubZone)
            
            NotificationDetails["apiReturn"].forEach(function(e){
              if(e.AlarmSubTypeId == enumAlertSubType.Low_Batteries)
                  e['SubName'] = "LB";
              else if(e.AlarmSubTypeId == enumAlertSubType.Lost_Communication)
                  e['SubName'] = "LC";
              else if(e.AlarmSubTypeId == enumAlertSubType.Failure)
                  e['SubName'] = "Failure";
              else if(e.AlarmSubTypeId == enumAlertSubType.Check_In_Report_Notification)
                  e['SubName'] = "CIN";
              else if(e.AlarmSubTypeId == enumAlertSubType.ADL_Alarm)
                  e['SubName'] = "ADL";
              else if(e.AlarmSubTypeId == enumAlertSubType.Fire_Alarm)
                  e['SubName'] = "Fire";
              else if(e.AlarmSubTypeId == enumAlertSubType.Nurse_Call_Alarm)
                  e['SubName'] = "NurseCall";
              else if(e.AlarmSubTypeId == enumAlertSubType.Environmental)
                  e['SubName'] = "EM";
              else if(e.AlarmSubTypeId == enumAlertSubType.Tag_In_Field)
                  e['SubName'] = "TIF";
              else if(e.AlarmSubTypeId == enumAlertSubType.Unauthorized)
                  e['SubName'] = "UE";
              else if(e.AlarmSubTypeId == enumAlertSubType.Lotiering)
                  e['SubName'] = "Loitering"; 
                  
              console.log("e.FloorId : " + e.FloorId)
              console.log("e.SubZoneId : " + e.SubZoneId)
                  
              if(e.Buildingname != '')
              {                  
                
                e['NewBuildingName'] = e.Buildingname.trim();
              }
              else
                e['NewBuildingName'] = "";
                
              if(e.FloorName != '')
              {                  
                e['NewFloorName'] = e.FloorName.trim();
              }
              else
                e['NewFloorName'] = "";
                
              if(e.SubZoneDesc != '' && e.SubZoneDesc != undefined)
              {                  
                e['NewSubZoneName'] = e.SubZoneDesc.trim();
              }
              else
                e['NewSubZoneName'] = "";
                
              if(_this.SubZone_Id == undefined)  
                _this.SubZone_Id = 0

              if (_this.Floor_Id == 0 && e.FloorId == 0 && _this.Building_Id == 0 && e.Buildid == 0 && e.CampusId == _this.Campus_Id && e.AlarmId == _this.AlarmId) {
                _this.Notificationdetails[_this.Notificationdetails.length] = e;
                if (_this.AlarmSubTypeId_Show == e.AlarmSubTypeId) {
                  first_showData[first_showData.length] = e;
                  DataValue[DataValue.length] = cnt;
                }
                else if (_this.AlarmSubTypeId_Show == "" && e.totcnt != null) {
                  first_showData[first_showData.length] = e;
                  DataValue[DataValue.length] = cnt;
                }
                cnt++;
              }
              else if (_this.SubZone_Id == 0 && _this.Floor_Id == 0 && e.FloorId == 0 && e.Buildid == _this.Building_Id && e.CampusId == _this.Campus_Id && e.AlarmId == _this.AlarmId) {
                _this.Notificationdetails[_this.Notificationdetails.length] = e;
                if (_this.AlarmSubTypeId_Show == e.AlarmSubTypeId) {
                  first_showData[first_showData.length] = e;
                  DataValue[DataValue.length] = cnt;
                }
                else if (_this.AlarmSubTypeId_Show == "" && e.totcnt != null) {
                  first_showData[first_showData.length] = e;
                  DataValue[DataValue.length] = cnt;
                }
                cnt++;
              }
              else if (_this.SubZone_Id == 0 && e.SubZoneId == 0 && _this.Floor_Id == e.FloorId && e.Buildid == _this.Building_Id && e.CampusId == _this.Campus_Id && e.AlarmId == _this.AlarmId) {
                _this.Notificationdetails[_this.Notificationdetails.length] = e;
                if (_this.AlarmSubTypeId_Show == e.AlarmSubTypeId) {
                  first_showData[first_showData.length] = e;
                  DataValue[DataValue.length] = cnt;
                }
                else if (_this.AlarmSubTypeId_Show == "" && e.totcnt != null) {
                  first_showData[first_showData.length] = e;
                  DataValue[DataValue.length] = cnt;
                }
                cnt++;
              }           
              else if (_this.SubZone_Id == 0 && e.SubZoneId == 0 && _this.Floor_Id == e.FloorId && e.Buildid == _this.Building_Id && e.CampusId == _this.Campus_Id && e.AlarmId == _this.AlarmId) {
                _this.Notificationdetails[_this.Notificationdetails.length] = e;
                if (_this.AlarmSubTypeId_Show == e.AlarmSubTypeId) {
                  first_showData[first_showData.length] = e;
                  DataValue[DataValue.length] = cnt;
                }
                else if (_this.AlarmSubTypeId_Show == "" && e.totcnt != null) {
                  first_showData[first_showData.length] = e;
                  DataValue[DataValue.length] = cnt;
                }
                cnt++;
              } 
              else if (_this.SubZone_Id == e.SubZoneId && _this.Floor_Id == e.FloorId && e.Buildid == _this.Building_Id && e.CampusId == _this.Campus_Id && e.AlarmId == _this.AlarmId) {
                _this.Notificationdetails[_this.Notificationdetails.length] = e;
                if (_this.AlarmSubTypeId_Show == e.AlarmSubTypeId) {
                  first_showData[first_showData.length] = e;
                  DataValue[DataValue.length] = cnt;
                }
                else if (_this.AlarmSubTypeId_Show == "" && e.totcnt != null) {
                  first_showData[first_showData.length] = e;
                  DataValue[DataValue.length] = cnt;
                }
                cnt++;
              }  
              
            });                                   
        }
        if (_this.Notificationdetails.length > 0) {
          var click_val = 0;
          if (this.AlarmSubTypeId_Show == "" && DataValue.length > 0) {
            click_val = DataValue[0];
            this.AlarmSubTypeId_Show = first_showData[0].AlarmSubTypeId;
          }
          else if (DataValue.length > 0) {

            click_val = DataValue[0];
            this.AlarmSubTypeId_Show = first_showData[0].AlarmSubTypeId;
          }
          else {
            click_val = 0;
            this.AlarmSubTypeId_Show = _this.Notificationdetails[0].AlarmSubTypeId;
          }
          this.clickcollapse(click_val, '', this.Campus_Id, this.AlarmSubTypeId_Show, this.Building_Id, this.Floor_Id, this.SubZone_Id);
        }
        else {
          this.clickcollapse(click_val, '', this.Campus_Id, "", this.Building_Id, this.Floor_Id, this.SubZone_Id);
        }

      });
  }
  catch (err) {
    throw new Error('notification.component.ts' + ' - getNotification() - ' + err.message);
  }
}

//show escalation details
clickcollapse(val,data,CampusId,AlarmSubTypeId,BuildId,FloorId,SubZoneId)
{
  try
  {
    this.AlarmSubTypeId_Show = AlarmSubTypeId;
    
    this.notifyloading = true;
    
    var p1 = 0;
    this.dataSource="";     
    this.checkicon = val;     
    this.esclationcount =-1; 
    this.esclationCampus=-1;
    this.esclationBuilding=-1;
    this.esclationFloor=-1;
    this.esclationSubZone = -1;
    this.esclationsubtypeid=-1;
    if(this.preId != -1 && this.preId != val)
    {
      p1++;
      if(this.collapsedIcon == "keyboard_arrow_down")
      {
        this.collapsedIcon1 = "keyboard_arrow_up";
        this.arrowiconT = true;
      }
    }
    if(this.checkicon == val)
    {
      
      if(this.collapsedIcon1 == "keyboard_arrow_down"  && p1 == 0)
      {
        this.collapsedIcon1 = "keyboard_arrow_up";
        this.arrowiconT = true;
      }
      else if(this.collapsedIcon1 == "keyboard_arrow_up"  && p1 == 0)
      {
        this.collapsedIcon1 = "keyboard_arrow_down";
        this.arrowiconT = false;
      }
      this.preId = val;
     
    }    
    var notificationRequestById : getNotificationById = 
    {
      siteId:this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      campusId:parseInt(CampusId),
      alarmId:this.AlarmId,
      buildId:parseInt(BuildId),
      floorId:parseInt(FloorId),
      subZoneId:parseInt(SubZoneId)
    };
    this.getNotificationRecipient(notificationRequestById, AlarmSubTypeId);
  }
  catch (err) {
    throw new Error('notification.component.ts' + ' - clickcollapse() - ' + err.message);
  }
}

getNotificationRecipient(notificationRequestById, AlarmSubTypeId)
{   
this.notificationService.getNotificationRecipient(notificationRequestById).pipe(takeUntil(this._onDestroy))
.subscribe((Escalationdetail : any[])=>{
  if (Escalationdetail !=null && Escalationdetail !=undefined && Escalationdetail.length > 0)
  {                         
            this.Escalationdetail = Escalationdetail;               
            var NotifyLevel = this.Escalationdetail.filter(function (e1) {                 
                return e1.AlarmSubTypeId == AlarmSubTypeId;
            });                                        
            for(var i = 0; i < NotifyLevel.length; i++)
            {              
              if(NotifyLevel[i].Level != 1)
              {                
                if((NotifyLevel[i-1].NeedRepeat == 1 && NotifyLevel[i-1].NeedEscalate == 0) || (NotifyLevel[i-1].NeedRepeat == 0 && NotifyLevel[i-1].NeedEscalate == 0))
                  NotifyLevel[i].showNotifyWarningImage = 1;
              }
              else
                NotifyLevel[i].showNotifyWarningImage = 0;
            }
            this.esclationcount=NotifyLevel.length;   
            this.checkNotificationCount = NotifyLevel.length;   
            this.esclationCampus=notificationRequestById.campusId;              
            this.esclationsubtypeid=AlarmSubTypeId;
            this.Building_Id = Escalationdetail[0].BuildId;              
            this.esclationBuilding=notificationRequestById.buildId;
            this.Building_Name = Escalationdetail[0].BuildingName;
            this.Floor_Id = Escalationdetail[0].FloorId;
            this.esclationFloor=notificationRequestById.floorId;
            this.Floor_Name = Escalationdetail[0].FloorName;
            this.esclationSubZone = notificationRequestById.subZoneId;
            this.SubZone_Id = Escalationdetail[0].SubZoneId;
            if(this.checkNotificationCount > 0)
            {
              if(NotifyLevel[0].ContiNotification == 1)
                this.checkNotification = true;
              else
                this.checkNotification = false; 
            }
            else
              this.checkNotification = true;  
            if(AlarmSubTypeId == enumAlertSubType.Staff_Geo && this.checkNotificationCount == 0)  
              this.checkNotification = false;
              
            this.dataSource = new MatTableDataSource( NotifyLevel);      
            this.dataSource.data =  NotifyLevel; 
            if(NotifyLevel.length > 0)
              this.contiNotifyAlertId = NotifyLevel[0].AlertId;
            this.notifyloading = false; 
            let elementcontent = document.getElementById('divmatnotifycontent');
            elementcontent.className = 'mat-content enablecontent'                           
  }   
  else
  {
    this.notifyloading = false;
    this.esclationcount=Escalationdetail.length;
    let elementcontent = document.getElementById('divmatnotifycontent');
    elementcontent.className = 'mat-content enablecontent'
    this.checkNotification = true;
    if(AlarmSubTypeId == enumAlertSubType.Staff_Geo && this.checkNotificationCount == 0)  
      this.checkNotification = false;
  }
  
  if(AlarmSubTypeId == enumAlertSubType.Low_Batteries || AlarmSubTypeId == enumAlertSubType.Lost_Communication)
    this.RepeatCycleTooltip = "Repeat Cycle(hours)";
  else
    this.RepeatCycleTooltip = "Repeat Cycle(minutes)";  
  if(AlarmSubTypeId == enumAlertSubType.Low_Batteries || AlarmSubTypeId == enumAlertSubType.Lost_Communication)  
    this.EscalateTooltip = "Time to Escalate(hours)";
  else
    this.EscalateTooltip = "Time to Escalate(minutes)";
  
  if(document. getElementById('matTargetId') != null)
    document. getElementById('matTargetId').setAttribute('id','');
    
  var selectedrow = document.getElementsByClassName("mat-header-row");
  selectedrow[0].setAttribute('id','targetId');
  document. getElementById('targetId').parentElement.parentElement.parentElement.parentElement.setAttribute('id','matTargetId');
  document. getElementById('matTargetId').scrollIntoView();    
});

}

// close Notification Dialog
public onCloseeditNotification = () => {
  this.thisDialogRef.close('Cancel');
  if(!SessionCheck(this.router))
  {
      return;
  }
  
}

/*********Open add dialogwindow*******/
addNotification(campusdetails,totcnt,CampusId,CampusName,Description,AlertId,AlarmId,AlarmSubTypeId,AlarmSubTypeName,AlarmNameId,BuildId,BuildingName,FloorId,FloorName,SubZoneId,SubZoneName) { 
  if(!SessionCheckwithStaff(this.router))
  {
      return;
  }
  console.log("campusdetails  :",campusdetails)
  if (AlarmSubTypeId=="") { AlarmSubTypeId=0}
  let Escdetails: any={
    CampusId: CampusId,
    CampusName: CampusName,
    EscalationLevel: totcnt+1,
    UDEventName: Description,
    AlarmId: AlarmId,
    AlertId : AlertId,
    AlarmSubTypeId:AlarmSubTypeId,
    AlarmSubTypeName: AlarmSubTypeName,
    AlarmNameId: AlarmNameId,
    BuildId: BuildId,
    BuildingName: BuildingName,
    FloorId: FloorId,
    FloorName: FloorName,
    SubZoneId: SubZoneId,
    SubZoneName:SubZoneName
  }
  let dialogRef = this.dialog.open(AddNotificationComponent, {
    disableClose: true,
    width: '1200px',
    height:'670px',
    panelClass: 'myapp-no-padding-dialog',
    autoFocus: false,
    data: Escdetails
});

dialogRef.afterClosed().subscribe(result => { 
  if(result== 'Confirm') 
  {
    this.collapsedIcon1 = "keyboard_arrow_down";
    this.AlarmSubTypeId_Show = AlarmSubTypeId;
    this.getNotification({siteId:this.SiteId,authKey: localStorage.getItem("Authkey"),alertId:parseInt(AlarmId),isOldUI:"0"});         
  } 

})
}

/*********Open edit dialogwindow*******/
editNotificationdata(data)
{
    if(!SessionCheckwithStaff(this.router))
    {
        return;
    }    
    
    var Building_Name = "";
    var Floor_Name = "";
    var subZone_Name = "";
    
    if(data.BuildingName == null)
      Building_Name = "";
    else
      Building_Name = data.BuildingName;
        
    if(data.FloorName == null)
      Floor_Name = "";
    else
      Floor_Name = data.FloorName;
      
    if(data.SubZoneName == null)
      subZone_Name = "";
    else
      subZone_Name = data.FloorName;
      
    let editdata: any = 
    {
      AlarmNameId: data.AlarmNameId,
      AlarmSubTypeId: data.AlarmSubTypeId,
      AlarmSubTypeName: data.AlarmSubTypeName,
      AlertId: data.AlertId,
      Area: data.Area,
      CampusId: data.CampusId,
      CampusName: data.CampusName,
      EventId: data.EventId,
      EventName: data.EventName,
      Level: data.Level,
      LevelImg: data.LevelImg,
      Notify: data.Notify,
      NotifyType: data.NotifyType,
      RoleId: data.RoleId,
      StaffId: data.StaffId,
      TimetoEscalate: data.TimetoEscalate,
      UDEventName: data.UDEventName,
      GroupId:data.GroupId,
      GroupType:data.GroupType,
      BuildingId:data.BuildId,
      BuildingName:Building_Name,
      FloorId:data.FloorId,
      FloorName:Floor_Name,
      SubZoneId:data.SubZoneId,
      SubZoneName:subZone_Name,
      RepeatCycle:data.RepeatCycle,
      NeedEscalate:data.NeedEscalate,
      NeedRepeat:data.NeedRepeat,
      RepeatNumber:data.RepeatNumber
    }
    let dialogRef = this.dialog.open(EditNotificationComponent, {
      disableClose: true,
      width: '1200px',
      height:'670px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: editdata
    });
  
    dialogRef.afterClosed().subscribe(result => { 
      if(result== 'Confirm') 
      {
        this.collapsedIcon1 = "keyboard_arrow_down";
        this.AlarmSubTypeId_Show = data.AlarmSubTypeId;
        this.getNotification({siteId:this.SiteId,authKey: localStorage.getItem("Authkey"),alertId:parseInt(data.EventId),isOldUI:"0"});                 
      }       
    })
}

/*********Open Delete dialogwindow*******/
deleteNotification(d_eventName,d_Campusname,d_AlertId,d_Level, d_AlarmId, CampusId, AlarmSubTypeId,BuildId,FloorId,SubZoneId)
{
  
  let elementcontent = document.getElementById('divmatnotifycontent');
  elementcontent.className = 'disablecontent';
  
  if (AlarmSubTypeId =="")
    AlarmSubTypeId=0;

  if(!SessionCheckwithStaff(this.router))
  {
      return;
  }
       
    var checkalertItem : checkAlertItem =
     {
       siteId: this.SiteId,
       authKey: localStorage.getItem("Authkey"),
       campusId:parseInt(CampusId),
       eventId: parseInt(d_AlarmId),
       subTypeId:parseInt(AlarmSubTypeId),
       buildId:parseInt(BuildId),
       floorId:parseInt(FloorId),
       subzoneId:parseInt(SubZoneId)
     }
    this.notificationService.checkAlertForCampus(checkalertItem).pipe(takeUntil(this._onDestroy))
    .subscribe((apiresponse : any[])=>{
      if(apiresponse.toString() == "true")
      {  
        generateAlertMessage(this.dialog, 'This notification  ' + d_eventName + " Alarm - " + d_Campusname + ' has open alerts, please complete or cancel those alerts and try again.')       
        let elementcontent = document.getElementById('divmatnotifycontent');
            elementcontent.className = 'mat-content enablecontent'
            return;
      }
      else
      {
        this.deleteMSG = "Are you sure you want to delete " + d_Campusname + " " + d_eventName + " Escalation " + d_Level + "? ";
        this.confirmation(d_AlertId,d_Level,d_AlarmId,AlarmSubTypeId,CampusId,BuildId,FloorId,SubZoneId)
      }
      
    });
   
}
confirmation(AlertId,EscalationLevel,d_AlarmId,AlarmSubTypeId,CampusId,BuildId,FloorId,SubZoneId)
{
  try
  {
   
    var ConfirmMessageData = {
      ConfirmMessage:  this.deleteMSG                
    }     
    let dialogRef = this.dialog.open(ConfirmMessageComponent, {
      disableClose: true,
      width: 'auto',
      height: '220px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: ConfirmMessageData
    });     
    dialogRef.afterClosed().subscribe(result => {     
      if(result == "Yes")
      {                     
         this.deletenotification(AlertId,EscalationLevel,d_AlarmId,AlarmSubTypeId,CampusId,BuildId,FloorId,SubZoneId);           
      }
      else
      {
          let elementcontent = document.getElementById('divmatnotifycontent');
          elementcontent.className = 'mat-content enablecontent'
          dialogRef.close('Cancel');          
          return;
      }
    });
  }
  catch(err)
  {
      throw new Error('notification.component.ts' + ' - confirmation() - ' + err.message);
  }   
}

deletenotification(AlertId,EscalationLevel,d_AlarmId,AlarmSubTypeId,CampusId,BuildId,FloorId,SubZoneId)
{

  var notification : NotificationDelete = {
    siteId: this.SiteId,
    authKey: localStorage.getItem("Authkey"),
    alertId:AlertId,
    level: EscalationLevel
   } 
    
  this.notificationService.deleteNotification(notification).pipe(takeUntil(this._onDestroy))
  .subscribe((apiresponse : NotificationForCreationResponse[])=>{     
      if (apiresponse["apiReturn"] !=null && apiresponse["apiReturn"] !=undefined)
      {          
            if(apiresponse["apiReturn"]['Status'] == 1)
            { 	
              if (apiresponse["apiReturn"]['countinfo']==3)
              {
                generateAlertMessage(this.dialog, 'In order to remove Escalation 1, please remove Escalation 3,2 and try again.')             
              }
              else
              {
                generateAlertMessage(this.dialog, 'In order to remove Escalation 1, please remove Escalation 2 and try again.')             
              }
	            let elementcontent = document.getElementById('divmatnotifycontent');
               elementcontent.className = 'mat-content enablecontent'
              return;
            }
            else if(apiresponse["apiReturn"]['Status'] == 2)
            { 	
              generateAlertMessage(this.dialog, 'In order to remove Escalation 2, please remove Escalation 3 and try again.')             
	            let elementcontent = document.getElementById('divmatnotifycontent');
               elementcontent.className = 'mat-content enablecontent'
              return;
            }
            else if(apiresponse["apiReturn"]['Status'] == 0)
            {
              var CheckAlertData = {
                "IsAlertChanged": 0,
                "IsAlertClicked": 0
              };
              this.alertSharedService.changeSharedCheckAlert(CheckAlertData);	
              CheckAlertData = {
                "IsAlertChanged": 1,
                "IsAlertClicked": 0
              };
              this.apiService.reloadNotification();         
              this.alertSharedService.changeSharedCheckAlert(CheckAlertData);
              generateAlertMessage(this.dialog, 'Escalation data deleted successfully.')             
            }
            else if(apiresponse["apiReturn"].toString() == "Fail")
            {
              generateAlertMessage(this.dialog, 'Escalation data deleted failed.')              
            } 
	          else if(apiresponse["apiReturn"] == "Invalid Auth Key")
            {                             
                AuthFailedMessage(this.dialog,this.router);  
                return;       
            } 
            let elementcontent = document.getElementById('divmatnotifycontent');
            elementcontent.className = 'mat-content enablecontent';
	          this.collapsedIcon1 = "keyboard_arrow_down"; 
            this.AlarmSubTypeId_Show = AlarmSubTypeId;        
            this.getNotification({siteId:this.SiteId,authKey: localStorage.getItem("Authkey"),alertId:parseInt(d_AlarmId),isOldUI:"0"});                                           
    }
  });
}

toggleNotifications(event)
{
  let continuousNotify = 0;
  if (event.checked == true) 
  {  
    this.checkNotification = true; 
    continuousNotify = 1; 
  }
  else
  {
    this.checkNotification = false;  
    continuousNotify = 0;
  }
    
    var continotification : any = {
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      continuousNotify:continuousNotify,
      alertId: this.contiNotifyAlertId
     } 
   
    this.notificationService.updateContinuousNotification(continotification).pipe(takeUntil(this._onDestroy))
    .subscribe((apiresponse : NotificationForCreationResponse[])=>{     
        if (apiresponse !=null && apiresponse !=undefined)
        {  
                  
        }
    })
    
}


ngOnDestroy() {
  this._onDestroy.next();
  this._onDestroy.complete();
  }
  
}
